import { Constants } from "@eagerdog/constants";
import { IShow } from "@eagerdog/interfaces";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace WeightPull {
  // Weight Pull historically had a single "Weight Pull" show_element (Division
  // A/B only). We later added per-surface elements (Wheels Natural, Wheels
  // Artificial, Snow, Rail) so shows can offer a subset of surfaces. New shows
  // are always set up with one or more of those surface elements — but many
  // existing/older events were posted before that change and only have the
  // single legacy "Weight Pull" show_element in show_elements. We have no way
  // of knowing which surfaces those events intended to offer, so for those
  // legacy shows we fall back to the original single Weight Pull
  // checkbox/Division A+B form instead of showing every new surface dropdown
  // as "(Unavailable)" (FormBuilder disables any dropdown whose label doesn't
  // match a configured show_element).
  const surfaceElements = [
    Constants.dog_class_element.weight_pull_wheels_natural,
    Constants.dog_class_element.weight_pull_wheels_artificial,
    Constants.dog_class_element.weight_pull_snow,
    Constants.dog_class_element.weight_pull_rail,
  ];

  const divisionOptions = [
    { value: "None", id: "None" },
    { value: Constants.dog_class_element_level.division_a, id: Constants.dog_class_element_level.division_a },
    { value: Constants.dog_class_element_level.division_b, id: Constants.dog_class_element_level.division_b }
  ];

  const newSurfacesForm: IEventRegisterRow[] = surfaceElements.map((label) => ({
    allowDuplicates: true,
    inputs: [{
      type: "dropdown", defaultValue: "None", label, options: divisionOptions
    }]
  }));

  // Legacy form, unchanged from how it looked before per-surface elements
  // were introduced.
  const legacyForm: IEventRegisterRow[] = [{
    allowDuplicates: false,
    inputs: [{
      type: "checkbox", label: Constants.dog_class_element.performance_weight_pull, multiSelect: true, options: [
        { value: Constants.dog_class_element_level.division_a, id: Constants.dog_class_element_level.division_a },
        { value: Constants.dog_class_element_level.division_b, id: Constants.dog_class_element_level.division_b }
        //{ value: Constants.dog_class_element_level.veteran, id: Constants.dog_class_element_level.veteran }
     ]
    }]
   }];

  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    const hasNewSurfaceElements = show?.show_elements?.some(
      (se) => surfaceElements.includes(se.show_element)
    ) ?? false;

    if (!show || hasNewSurfaceElements) {
      return newSurfacesForm;
    }

    return legacyForm;
  };

  // Kept for any callers that haven't been updated to pass the show — defaults
  // to the current (new surfaces) form, matching every newly created show.
  export const form: IEventRegisterRow[] = getForm();
}
